module.exports = __webpack_public_path__ + "assets/7b2134b03dbec6c5b5472923ceb6cd86.mp3";